// withRouter.tsx
import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

export function withRouter(Component: any) {
  function ComponentWithRouterProp(props: any) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    return (
      <Component
        {...props}
        router={{ navigate, location, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}
